import ResponseEntity, {
  DtoConversionError,
  enumConvert,
  RequestEntity,
} from "..";

export enum OutputStructureGroup {
  "committee" = "committee",
  "division" = "division",
  "project" = "project",
  "member-full" = "member-full",
  "member-obs" = "member-obs",
}

export default class OutputStructure extends ResponseEntity {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly nameShort: string,
    public readonly url: string | undefined | null,
    public readonly logoSimpleWhite: string | undefined | null,
    public readonly logoSimpleColor: string | undefined | null,
    public readonly logoText: string,
    public readonly logoTextIsImage: boolean,
    public readonly color: number,
    public readonly group: OutputStructureGroup
  ) {
    super(id);
  }

  static convert(input: any): OutputStructure {
    if (input instanceof OutputStructure) return input;

    const id = input.id ?? undefined;
    const name = input.name ?? undefined;
    const name_short = input.name_short ?? undefined;
    const url = input.url ?? undefined;
    const logo_simple_white = input.logo_simple_white ?? undefined;
    const logo_simple_color = input.logo_simple_color ?? undefined;
    const logo_text = input.logo_text ?? undefined;
    const logo_text_is_image = input.logo_text_is_image ?? undefined;
    const color = input.color ?? undefined;
    const group = input.group ?? undefined;

    if (typeof id !== "string")
      throw new OutputStructureConversionError("id", input);
    if (typeof name !== "string")
      throw new OutputStructureConversionError("name", input);
    if (typeof name_short !== "string")
      throw new OutputStructureConversionError("name_short", input);
    if (typeof url !== "string" && typeof url !== "undefined")
      throw new OutputStructureConversionError("url", input);
    if (
      typeof logo_simple_white !== "string" &&
      typeof logo_simple_white !== "undefined"
    )
      throw new OutputStructureConversionError("logo_simple_white", input);
    if (
      typeof logo_simple_color !== "string" &&
      typeof logo_simple_color !== "undefined"
    )
      throw new OutputStructureConversionError("logo_simple_color", input);
    if (typeof logo_text !== "string")
      throw new OutputStructureConversionError("logo_text", input);
    if (typeof logo_text_is_image !== "boolean")
      throw new OutputStructureConversionError("logo_text_is_image", input);
    if (typeof color !== "number")
      throw new OutputStructureConversionError("color", input);
    if (typeof group !== "string")
      throw new OutputStructureConversionError("group", input);

    return OutputStructureConversionError.propagate(
      OutputStructureConversionError.dtoName,
      () =>
        new OutputStructure(
          id,
          name,
          name_short,
          url,
          logo_simple_white,
          logo_simple_color,
          logo_text,
          logo_text_is_image,
          color,
          enumConvert(OutputStructureGroup, group)
        )
    );
  }
}

class OutputStructureConversionError extends DtoConversionError {
  public static dtoName: string = "OutputStructure";
  constructor(propertyName: string, rawData: any, hint?: string) {
    super(OutputStructureConversionError.dtoName, propertyName, rawData, hint);
  }
}

export class RequestStructuresByGroup extends RequestEntity {
  constructor(public readonly group: OutputStructureGroup) {
    super();
  }
}
